// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2Bj1D","title":"ClientInsurance_title__16CCP","itemText":"ClientInsurance_itemText__UvFxi"};